import { BRAND } from "../../../constants/brand";

const links = [
  ["Help center", BRAND.urls.support, true],
  ["T&Cs", "/terms-and-conditions"],
  ["EULA", "/eula"],
  ["Acceptable Use Policy", "/acceptable-use-policy"],
  ["Community Guidelines", "/community-guidelines"],
  ["Privacy Policy", "/privacy-policy"],
  ["Cookies Policy", "/cookies-policy"],
  ["Online Safety Policy", "/online-safety-policy"],
  ["Next of Kin Policy", "/next-of-kin-policy"],
  ["Disclaimer", "/disclaimer"]
];

const socials = [
  ["X", BRAND.urls.twitter, "/live/social-x.png", 32, 32],
  ["Facebook", BRAND.urls.facebook, "/live/icon-facebook.png", 15, 15],
  ["Instagram", BRAND.urls.instagram, "/live/social-instagram.png", 32, 32],
  ["LinkedIn", BRAND.urls.linkedin, "/live/social-linkedin.png", 32, 32]
];

export default function SiteFooter() {
  return (
    <footer className="site-footer" id="enquire">
      <div className="cta">
        <h2 className="cta__title trim">It takes a community to raise a child...<br className="br-d" /> Both online and offline</h2>
        <p className="cta__text">Start your child’s safer online community experience today.</p>
        <a className="btn btn--black" href="#enquire"><span className="trim">Enquire Now</span></a>
      </div>
      <div className="footer-bottom">
        <hr className="rule" />
        <div className="footer-links">
          <ul className="footer-links__list">
            {links.flatMap(([label, href, external]) => [
              <li key={href}>
                <a
                  href={href}
                  {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                >
                  {label}
                </a>
              </li>,
              <li key={`${href}-sep`} className="sep" aria-hidden="true">|</li>
            ])}
          </ul>
          <ul className="socials">
            {socials.map(([label, href, src, width, height]) => (
              <li key={label}>
                <a className={label === "Facebook" ? "socials__fb" : undefined} href={href} aria-label={label} target="_blank" rel="noopener noreferrer">
                  <img src={src} width={width} height={height} alt="" />
                </a>
              </li>
            ))}
          </ul>
        </div>
        <hr className="rule" />
        <div className="footer-meta">
          <a className="brand" href="/" aria-label="Imprint.live home">
            <img className="brand__hand" src="/live/logo-hand-footer.png" width="38" height="50" alt="" />
            <img className="brand__wordmark" src="/live/logo-wordmark.png" width="142" height="14" alt="IMPRINT.LIVE" />
          </a>
          <p className="footer-meta__copy">© 2026 IMPRINT.LIVE. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
